











import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import { Emit, Watch } from "vue-property-decorator";
import BaseComponent from "@/utils/baseComponent";
import SelectedCustomers from "@/components/common/SelectedCustomers.vue"
import { SelectedCustomersInterface } from "@/types/selectedCustomersInterface";
const namespace = "communication";

@Component({
    components: {
         SelectedCustomers
    }
})

export default class TestComponents extends BaseComponent {
    async  mounted(){        
        const selecteCustomers = this.$refs.childComponent as  SelectedCustomersInterface;
            selecteCustomers.changeSelectedCustomers(false, false, true, '48244');
    }


}

